export default "__VITE_ASSET__8da4ce5d__"